import React from "react";

export const IconSave = () => {
    return (
        <svg
            width="24"
            height="25"
            viewBox="0 0 24 25"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
        >
            <path
                d="M20.5603 7.25L17.25 3.93969C17.1112 3.79979 16.946 3.68888 16.764 3.6134C16.582 3.53792 16.3867 3.49937 16.1897 3.5H4.5C4.10218 3.5 3.72064 3.65804 3.43934 3.93934C3.15804 4.22064 3 4.60218 3 5V20C3 20.3978 3.15804 20.7794 3.43934 21.0607C3.72064 21.342 4.10218 21.5 4.5 21.5H19.5C19.8978 21.5 20.2794 21.342 20.5607 21.0607C20.842 20.7794 21 20.3978 21 20V8.31031C21.0006 8.11326 20.9621 7.91804 20.8866 7.73602C20.8111 7.55399 20.7002 7.38878 20.5603 7.25ZM15.75 20H8.25V14.75H15.75V20ZM19.5 20H17.25V14.75C17.25 14.3522 17.092 13.9706 16.8107 13.6893C16.5294 13.408 16.1478 13.25 15.75 13.25H8.25C7.85218 13.25 7.47064 13.408 7.18934 13.6893C6.90804 13.9706 6.75 14.3522 6.75 14.75V20H4.5V5H16.1897L19.5 8.31031V20ZM15 7.25C15 7.44891 14.921 7.63968 14.7803 7.78033C14.6397 7.92098 14.4489 8 14.25 8H9C8.80109 8 8.61032 7.92098 8.46967 7.78033C8.32902 7.63968 8.25 7.44891 8.25 7.25C8.25 7.05109 8.32902 6.86032 8.46967 6.71967C8.61032 6.57902 8.80109 6.5 9 6.5H14.25C14.4489 6.5 14.6397 6.57902 14.7803 6.71967C14.921 6.86032 15 7.05109 15 7.25Z"
                fill="#08212D"
            />
        </svg>
    );
};
